import React, { useState } from 'react';
import { RoundedButton } from './RoundedButton';
import { IconButton } from './IconButton';
import { IconSearch, IconFilter } from '../Icons';
import OrderSearchExample from '../OrderSearchExample';

export interface ButtonBarProps {
    id?: string;
    content?: Array<{ label?: string } | string>;
    onSelect?: (index: number) => void;
    onSearch?: () => void;
    onFilter?: () => void;
}

export const ButtonBar: React.FC<ButtonBarProps> = props => {
    const [selected, setSelected] = useState<number>(0);

    const onSelect = (index: number) => {
        setSelected(index);
        props.onSelect?.(index);
    };

    return (
        <div className='flex'>
            <div className={'rounded-button-bar'} id={props.id}>
                {props.content?.map((e, i) => (
                    <RoundedButton
                        data-pw={typeof e === 'string' ? e : (e as any).id}
                        key={i}
                        label={typeof e === 'string' ? e : e.label}
                        selected={i === selected}
                        onClick={() => onSelect(i)}
                    />
                ))}

                {(props.onSearch ?? props.onFilter) && <span className="mx-1" />}

                {props.onSearch && (
                    <IconButton data-pw="button-search" onClick={props.onSearch}>
                        <IconSearch />
                    </IconButton>
                )}
                {props.onFilter && (
                    <IconButton data-pw="button-filter" onClick={props.onFilter}>
                        <IconFilter />
                    </IconButton>
                )}
            </div>
            <OrderSearchExample />
        </div>
    );
};
